import { useQuery } from 'react-query'
import { getUsers } from 'services/cmAPI/getUsers'

export function useUsers(customerId) {
  return useQuery(['getUsers' + customerId], () => getUsers(customerId), {
    enabled: Boolean(customerId),
  })
}
